import React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from 'react-router-dom';
import configData from "./config.json";
import Cookies from 'js-cookie';
// var CryptoJS = require("crypto-js");

function ForgotPassword() {

  // State variables
  const [username, setUsername] = useState('');
  // eslint-disable-next-line
  const [usernameError, setUsernameError] = useState('');
  const [loginStart, setLoginStart] = useState(false);
  
  // eslint-disable-next-line
  const [apiSuccessMessage, setApiSuccessMessage] = useState('');
  const [apiErrorMessage, setApiErrorMessage] = useState('');

  // eslint-disable-next-line
  const navigate = useNavigate();

  const isEmail = (email) => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);

  const doUserLogIn = async function () {
    setUsernameError('');
    setApiErrorMessage('');
    if (username !== '') {
      if (!isEmail(username)) {
        setUsernameError('Invalid Email');
      } else {
        setLoginStart(true);
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: username })
        };
        try {
          fetch(configData.SERVER_URL+"/forgotPassword", requestOptions)
            .then(response => {
              return response.json()
            })
            .then(results => {
              if (results.success === true) {
                // if (results.data.status === true) {
                //   Cookies.set('emailAuthenticated', results.success, { expires: 7 });
                //   Cookies.set('user', CryptoJS.AES.encrypt(JSON.stringify({"user_type": results.data.user.type,"name": results.data.user.name,"email": results.data.user.email,"company": results.data.user.company,"google_id": results.data.user.google,"aniview_id": results.data.user.aniview,"adkernel_id": results.data.user.adkernel}), 'XJ3ou%#1').toString(), { expires: 7 });
                //   Cookies.remove('registration_msg');
                //   navigate("/otp");
                // } else {
                //   setApiErrorMessage(results.message);
                // }
                // navigate("/", { state: { successMessage: results.message } });
                sessionStorage.setItem("successMessage", results.message);
                setApiSuccessMessage(results.message);
                navigate("/");
              } else {
                setApiErrorMessage(results.message);
              }
              setLoginStart(false);
            }).catch(error=>{
              alert("There is some error in processing your request. Please try again in some time.");
            })
          return true;
        } catch (error) {
          setApiErrorMessage('Something went wrong. Please Try Again.');
          return false;
        }
      }
    } else {
      setUsernameError('This field is required.');
    }
  };

  const keyDownHandler = event => {
    setUsernameError('');
    if (event.key === 'Enter') {
      event.preventDefault();
      doUserLogIn();
    }
  }

  useEffect(() => {
    // const cookieValue = Cookies.get("user");
    // if (cookieValue) {
    //   setUsername(JSON.parse(CryptoJS.AES.decrypt(Cookies.get('user'), 'XJ3ou%#1').toString(CryptoJS.enc.Utf8)).email);
    // }
    const flashEmail = sessionStorage.getItem("flashEmail");
    if (flashEmail) {
      setUsername(flashEmail);
      // Clear the message from sessionStorage after it has been displayed
      sessionStorage.removeItem("flashEmail");
    }
  }, []);

  if (!Cookies.get('status')) {
    return (

      <div className="d-flex bg_main justify-content-between">
        <div className="login_content">
          <div className="login_text">
            <h2 className="login_heading">Harnessing Data to Drive Smarter Advertising Decisions.</h2>
            <p>Elevate Your Website's Ad Placement Strategy with<br /> Advanced Analytics.</p>
          </div>
          <div className="login_img">
            <img src="assets/media/images/login_img.svg" alt="login" />
          </div>
        </div>

        <div className="login_form d-flex align-items-center justify-content-center">
          <div className="login_form_inner">
            
            {/* <div className="success_message" style={{ display: 'none' }}>
              <div className="d-flex align-items-center">
                <div className="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                    <path d="M13.9999 2.33325L17.0641 4.56859L20.8575 4.56159L22.0225 8.17125L25.0955 10.3949L23.9165 13.9999L25.0955 17.6049L22.0225 19.8286L20.8575 23.4383L17.0641 23.4313L13.9999 25.6666L10.9356 23.4313L7.14221 23.4383L5.9773 19.8286L2.9043 17.6049L4.08321 13.9999L2.9043 10.3949L5.9773 8.17125L7.14221 4.56159L10.9356 4.56859L13.9999 2.33325Z" stroke="#008500" strokeWidth="2.33333" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M9.91675 13.9999L12.8334 16.9166L18.6667 11.0833" stroke="#008500" strokeWidth="2.33333" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
                <div className="text">
                  <span className="error">{apiErrorMessage}</span>
                  <span className="success">{apiSuccessMessage}</span>
                  <h5 className="succcess_heading">Thank You</h5>
                  <p>Please check you email for Password reset link.</p>
                  <h5 className="succcess_heading">{apiSuccessMessage}</h5>
                </div>
              </div>
            </div> */}

            {apiErrorMessage && <div className="error_message">
              <div className="d-flex align-items-center">
                <div className="icon">
                <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" clipRule="evenodd" d="M5.61636 23.8429H22.3965C24.2422 23.8429 25.4007 21.8479 24.4837 20.2449L16.1 5.58571C15.1772 3.97221 12.8509 3.97104 11.9269 5.58454L3.52919 20.2437C2.61219 21.8467 3.76953 23.8429 5.61636 23.8429Z" stroke="#ED0017" strokeWidth="2.33" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M14.003 15.6506V12.0339" stroke="#ED0017" strokeWidth="2.33" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M13.9942 19.2498H14.0059" stroke="#ED0017" strokeWidth="2.33" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                </div>
                <div className="text">
                  <h5 className="succcess_heading">{apiErrorMessage}</h5>
                </div>
              </div>
            </div>}

            <div className="form_group">
            <h1 className="heading mb_10px">Forgot Password</h1>
              <p className='forgot-pass-txt mb_55px'>Enter your email address and we’ll send you a link to reset your password.</p>
            </div>
            <div className="form_group mb_5px">
              <label htmlFor="exampleFormControlInput1" className="form-label">Email Address</label>
              <div className={(username) ? 'input-group flex-nowrap w-100 active' : 'input-group flex-nowrap w-100'}>
                <span className="input-group-text" id="addon-wrapping">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" className="fill">
                    <path d="M10 17C9.04333 17 8.13917 16.8161 7.2875 16.4484C6.43583 16.0807 5.69197 15.579 5.0559 14.9434C4.4203 14.3078 3.91863 13.5642 3.5509 12.7125C3.18317 11.8608 2.99953 10.9567 3 10C3 9.03167 3.18387 8.12447 3.5516 7.2784C3.91933 6.43233 4.421 5.69173 5.0566 5.0566C5.6922 4.42053 6.4356 3.91887 7.2868 3.5516C8.138 3.18433 9.0424 3.00047 10 3C10.9683 3 11.8755 3.18387 12.7216 3.5516C13.5677 3.91933 14.3083 4.421 14.9434 5.0566C15.5795 5.6922 16.0811 6.43303 16.4484 7.2791C16.8157 8.12517 16.9995 9.03213 17 10V11.015C17 11.7033 16.7639 12.2897 16.2916 12.7741C15.8193 13.2585 15.2388 13.5005 14.55 13.5C14.13 13.5 13.7392 13.4067 13.3775 13.22C13.0158 13.0333 12.7183 12.7883 12.485 12.485C12.17 12.8 11.7995 13.048 11.3734 13.2291C10.9473 13.4102 10.4895 13.5005 10 13.5C9.03167 13.5 8.20613 13.1586 7.5234 12.4759C6.84067 11.7932 6.49953 10.9679 6.5 10C6.5 9.03167 6.84137 8.20613 7.5241 7.5234C8.20683 6.84067 9.03213 6.49953 10 6.5C10.9683 6.5 11.7939 6.84137 12.4766 7.5241C13.1593 8.20683 13.5005 9.03213 13.5 10V11.015C13.5 11.3533 13.605 11.6186 13.815 11.8109C14.025 12.0032 14.27 12.0995 14.55 12.1C14.83 12.1 15.075 12.0036 15.285 11.8109C15.495 11.6182 15.6 11.3529 15.6 11.015V10C15.6 8.47167 15.0486 7.15613 13.9459 6.0534C12.8432 4.95067 11.5279 4.39953 10 4.4C8.47167 4.4 7.15613 4.95137 6.0534 6.0541C4.95067 7.15683 4.39953 8.47213 4.4 10C4.4 11.5283 4.95137 12.8439 6.0541 13.9466C7.15683 15.0493 8.47213 15.6005 10 15.6H12.8C12.9983 15.6 13.1647 15.6672 13.2991 15.8016C13.4335 15.936 13.5005 16.1021 13.5 16.3C13.5 16.4983 13.4328 16.6647 13.2984 16.7991C13.164 16.9335 12.9979 17.0005 12.8 17H10ZM10 12.1C10.5833 12.1 11.0792 11.8958 11.4875 11.4875C11.8958 11.0792 12.1 10.5833 12.1 10C12.1 9.41667 11.8958 8.92083 11.4875 8.5125C11.0792 8.10417 10.5833 7.9 10 7.9C9.41667 7.9 8.92083 8.10417 8.5125 8.5125C8.10417 8.92083 7.9 9.41667 7.9 10C7.9 10.5833 8.10417 11.0792 8.5125 11.4875C8.92083 11.8958 9.41667 12.1 10 12.1Z" />
                  </svg>
                </span>
                <input type="email" className="form_control" placeholder="example@gmail.com" aria-label="UserID" aria-describedby="addon-wrapping" value={username} onChange={(event) => setUsername(event.target.value)} onKeyDown={keyDownHandler} />
              </div>
              {/* <span className="error mb-2">{usernameError}{apiErrorMessage}</span> */}
            </div>

            <div className="form_group mb-0 mt_26px">
              <button type="button" className={(loginStart) ? 'btn_primary loading_btn' : 'btn_primary'} onClick={() => doUserLogIn()}>
                {
                  (loginStart)
                    ?
                    <>
                      <span className="loader_text hide">REQUESTING... <i className="fa fa-spinner fa-spin ms-1"></i></span>
                    </>
                    :
                    <>
                      <span className="btn_text">REQUEST RESET LINK</span>
                    </>
                }
              </button>
            </div>
            {/* <span className="success">{apiSuccessMessage}</span> */}
            <div className="form_group mb_50px text-center">
              <Link to='/'><button className="loginModeBtn otpBtn backToSigninFromForgotPassword" type="button">Back to Sign In</button></Link>
            </div>
          </div>
        </div>
      </div >
    );
  } else {
    window.location.href = "/dashboard";
  }
}

export default ForgotPassword;